export interface CommonProps<VALIDATION = []> {
    label?: string;
    validation?:
        | string
        | Array<[rule: string, value?: string | number | boolean | RegExp] | [rule: string] | VALIDATION>;
    type?: never;
}

export enum RenderDirection {
    Horizontal = "horizontal",
    Vertical = "vertical",
}
